import { Box } from '@mui/material'

import { CustomTabPanelProps } from '@/components/Diagram'

export const MuiTabPanel = ({
	children,
	value,
	index,
	isTable = false,
	...other
}: CustomTabPanelProps) => {
	const isVisible = value === index

	const getWrapper = () => {
		if (isTable) {
			return <>{children}</>
		}

		return <Box sx={{ padding: '2rem 1rem' }}>{children}</Box>
	}
	return (
		<div
			role="tabpanel"
			hidden={!isVisible}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			style={
				isVisible
					? {
							flex: 1,
							minHeight: 0,
							display: 'flex',
							flexDirection: 'column',
							overflow: 'hidden',
						}
					: undefined
			}
			{...other}
		>
			{isVisible && getWrapper()}
		</div>
	)
}
